const theme = {
  brand: {
    main: '#ee0099',
    dark: '#000',
    light: '#fff',
  },
  commons: {
    dark: '#4A4A4A',
    main: '#aaa',
    light: '#eee',
  },
  fontFamily: "'Nunito Sans', sans-serif",
  body: {
    padding: 60,
    background: {
      light: '#fff',
      main: 'rgb(247,247,247)',
      dark: '#000',
    },
  },
  default: {
    color: {
      main: '#fff',
    },
    border: {
      main: '#ee0099',
    },
    background: {
      main: '#ee0099',
      hover: '#e2058a',
      focus: '#b4006c',
    },
  },
  dark: {
    color: {
      main: '#000',
      hover: '#4A4A4A',
      focus: '#9b9b9b',
    },
    border: {
      main: '#000',
      hover: '#4A4A4A',
      focus: '#9b9b9b',
    },
    background: {
      main: 'none',
    },
  },
  light: {
    color: {
      main: '#fff',
      hover: '#9b9b9b',
      focus: '#4A4A4A',
    },
    border: {
      main: '#fff',
      hover: '#eee',
      focus: '#4A4A4A',
    },
    background: {
      main: 'none',
    },
  },
  secondary: {
    color: {
      main: '#000',
      hover: '#424242',
      focus: '#9B9B9B',
    },
    border: {
      main: 'transparent',
      hover: 'transparent',
      focus: 'transparent',
    },
    background: {
      main: 'none',
    },
    disabled: {
      color: {
        main: '#AAAAAA',
        hover: '#AAAAAA',
        focus: '#AAAAAA',
      },
      background: {
        main: 'none',
      },
    },
  },
  error: '#FF2B4E',
};

export default theme;
